const locale = {
  'shoppingCart.title.shoppingCart': 'Корзина',
  'shoppingCart.text.total': 'Итого:',
  'shoppingCart.text.totalContent': '{total} SKU, всего {totalCount} товаров',
  'shoppingCart.button.deleteCommodity': 'Удалить товары',
  'shoppingCart.button.clearQuantity': 'Сбросить количество',
  'shoppingCart.modal.deleteCommodity': `Удалить выбранный товар`,
  'shoppingCart.modal.clearQuantity': 'Сбросить количество выбранных товаров?',
  'shoppingCart.button.exportSelected': 'Экспортировать выбранное',
  'shoppingCart.notification.export.message': 'Выбранные товары экспортированы',
  'shoppingCart.notification.export.description': 'Проверьте загрузки в браузере',
  'shoppingCart.import.rule1': '1. Поддерживается только импорт файлов xlsx',
  'shoppingCart.import.rule2':
    '2. Для обновления списка используйте таблицу ниже. Столбцы, отмеченные *, обязательны для заполнения',
  'shoppingCart.import.rule3':
    '3. После подтверждения будет обновлено количество для существующих артикулов',
  'shoppingCart.button.batchUpdateQuantity': 'Массовое обновление количества',
  'shoppingCart.message.emptyCart': 'Корзина пуста, массовое обновление невозможно.',
  'shoppingCart.message.emptyUpdateData':
    'Нет данных для обновления, массовое обновление невозможно.',
  'shoppingCart.import.partNumber': 'Артикул',
  'shoppingCart.import.brand': 'Бренд',
  'shoppingCart.import.quantity': 'Количество',
  'shoppingCart.message.invalidCheckedCartItems':
    'Некоторые количества товаров не соответствуют требованиям, пожалуйста, проверьте',
  'shoppingCart.message.differentStoreCartItems':
    'Вы можете проверить любой магазин один раз за раз',
};

export default locale;
